import type { ApiClient } from "@/shared/api/client";
import { API_BASE_URL } from "@/config/env";

export interface HomeBanner {
  id: string;
  imageUrl: string;
  alt: string;
  ctaHref: string;
  visible: boolean;
  eyebrow: string;
  titleLines: string[];
  subtitle: string;
  textTone: "light" | "dark";
}
export interface BannerConfig {
  enabled: boolean;
  revision: number;
  banners: HomeBanner[];
}
export const createHomeBannerService = (client: ApiClient) => ({
  uploadImage: (file: File) => {
    const form = new FormData();
    form.append("file", file);
    return client.post<{
      url: string;
      width: number;
      height: number;
      size: number;
      format: string;
    }>("/home-banners/images", form);
  },
  read: () => client.get<BannerConfig>("/home-banners/manage"),
  save: (config: BannerConfig) => client.put<BannerConfig>("/home-banners/manage", config),
});

export async function loadPublicHomeBanners(): Promise<HomeBanner[]> {
  const response = await fetch(`${API_BASE_URL}/home-banners`, { cache: "no-store" });
  if (!response.ok) throw new Error("배너를 불러오지 못했습니다");
  return (await response.json()).banners;
}
